( function () {
	'use strict';

	function listItem () {
		function link ( scope ) {
			function activate () {
				scope.isCollapsed = true;
				scope.area        = 'section';

				if ( scope.item.groupId ) {
					scope.area = 'indicator';
				}
			}

			activate();
		}

		var directive = {
			'link'        : link,
			'restrict'    : 'E',
			'scope'       : false,
			'templateUrl' : '/templates/components/evidences/script/list-item.html'
		};

		return directive;
	}

	angular.module( 'app.components' )
		.directive( 'listItem', listItem );
} )( );
